var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-broken"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M40.8333 20.8242V22.5108C40.831 26.4643 39.5509 30.3111 37.1837 33.4775C34.8166 36.6439 31.4893 38.9604 27.6981 40.0813C23.9069 41.2022 19.8549 41.0676 16.1465 39.6976C12.438 38.3275 9.27183 35.7953 7.12005 32.4788C4.96828 29.1622 3.94624 25.2389 4.20637 21.2941C4.46649 17.3492 5.99484 13.5941 8.56347 10.5888C11.1321 7.58349 14.6034 5.48902 18.4596 4.61775C22.3159 3.74649 26.3505 4.1451 29.9616 5.75415M40.8333 7.83366L22.5 26.1853L17 20.6853",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBroken);
export default __webpack_public_path__ + "static/media/check-circle-broken.7ccda99e32f926422a58b3dbfd07283d.svg";
export { ForwardRef as ReactComponent };